import { render, staticRenderFns } from "./ClimbingPricesTable.vue?vue&type=template&id=027f4a26&scoped=true&"
import script from "./ClimbingPricesTable.vue?vue&type=script&lang=js&"
export * from "./ClimbingPricesTable.vue?vue&type=script&lang=js&"
import style0 from "./ClimbingPricesTable.vue?vue&type=style&index=0&id=027f4a26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f4a26",
  null
  
)

export default component.exports